/*
  HISTORYページの年表（PCの1年ずつの差し替え）

  実装仕様
  #1 741px 以上のときだけ「1年ずつ」に切り替える。切り替えは
     c-hist-tl--live を付けることで行い、**このクラスが無ければ21年が
     そのまま縦に積まれて全部読める**。JSが読めなかったときの状態がそれ
  #2 現在地はスクロール位置から出す。画面の中央にいちばん近い送り枠を
     その時の年とする。IntersectionObserver ではなくスクロール計算にしているのは、
     送り枠が画面より高く「今どれが中央か」を連続して知る必要があるため
  #3 軸の年号を押すとその年へ飛ぶ。マークアップ上はページ内リンクなので、
     JSが動かなくても飛び先（各年の article）に着く
  #4 軸が横にはみ出す幅のときは、現在地が中央に来るよう軸を横に送る
  #5 幅が741pxを跨いだら組み直す。PCからSPへ戻したときに
     絶対配置のまま残らないようにする
  #6 shopify:section:load で作り直す（テーマエディタ対策）
  #11 年号軸は年の数だけ等分して画面内に収める。それでも収まらないときだけ
     横スクロールになるので、そのときは端にぼかしを出す（is-scrollable）
*/
(function () {
  'use strict';

  var LIVE = 'c-hist-tl--live';
  var ON = 'is-on';
  var PAST = 'is-past';
  var PC = '(min-width: 741px)';

  var instances = [];

  function Timeline(root) {
    this.root = root;
    this.entries = [].slice.call(root.querySelectorAll('[data-c-hist-tl-entry]'));
    this.steps = [].slice.call(root.querySelectorAll('[data-c-hist-tl-step]'));
    this.jumps = [].slice.call(root.querySelectorAll('[data-c-hist-tl-jump]'));
    this.rail = root.querySelector('[data-c-hist-tl-rail]');
    this.current = -1;
    this.live = false;

    this.onScroll = this.update.bind(this);
    this.onResize = this.sync.bind(this);

    this.bindJumps();
    this.sync();

    window.addEventListener('resize', this.onResize);
  }

  /* 実装仕様 #1 #5 */
  Timeline.prototype.sync = function () {
    var wantLive = window.matchMedia(PC).matches && this.steps.length > 0;
    if (wantLive === this.live) {
      if (this.live) {
        this.measureAxis();
        this.update();
      }
      return;
    }
    this.live = wantLive;
    this.root.classList.toggle(LIVE, wantLive);

    if (wantLive) {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.current = -1;
      this.measureAxis();
      this.update();
    } else {
      window.removeEventListener('scroll', this.onScroll);
      this.reset();
    }
  };

  /* SPへ戻したときに状態を残さない */
  Timeline.prototype.reset = function () {
    for (var i = 0; i < this.entries.length; i++) {
      this.entries[i].classList.remove(PAST);
      this.entries[i].classList.toggle(ON, i === 0);
    }
    for (var j = 0; j < this.jumps.length; j++) {
      this.jumps[j].classList.toggle(ON, j === 0);
    }
  };

  /* 実装仕様 #2 */
  Timeline.prototype.update = function () {
    var h = window.innerHeight;
    var mid = h / 2;
    var best = -1;
    var bestD = Infinity;

    for (var i = 0; i < this.steps.length; i++) {
      var r = this.steps[i].getBoundingClientRect();
      if (r.bottom <= 0 || r.top >= h) continue;
      var d = Math.abs((r.top + r.bottom) / 2 - mid);
      if (d < bestD) {
        bestD = d;
        best = i;
      }
    }

    if (best < 0 || best === this.current) return;
    this.current = best;
    this.show(best);
  };

  Timeline.prototype.show = function (index) {
    for (var i = 0; i < this.entries.length; i++) {
      var el = this.entries[i];
      el.classList.toggle(ON, i === index);
      el.classList.toggle(PAST, i < index);
    }

    /*
      実装仕様 #10。軸は同じ年をひとつにまとめてあるので、
      軸の並びと画面の並びは数が合わない。年の文字列で突き合わせる
    */
    var year = this.entries[index].getAttribute('data-c-hist-tl-year');
    var chip = null;
    for (var j = 0; j < this.jumps.length; j++) {
      var hit = this.jumps[j].getAttribute('data-c-hist-tl-year') === year;
      this.jumps[j].classList.toggle(ON, hit);
      if (hit && !chip) chip = this.jumps[j];
    }
    this.centreAxis(chip);
  };

  /*
    実装仕様 #11。年が増えて収まらなくなったときだけ、端のぼかしを出す。
    収まっている間は横スクロールしないので、ぼかしも要らない
  */
  Timeline.prototype.measureAxis = function () {
    var rail = this.rail;
    if (!rail || !rail.parentNode) return;
    rail.parentNode.classList.toggle('is-scrollable', rail.scrollWidth > rail.clientWidth + 1);
  };

  /* 実装仕様 #4 */
  Timeline.prototype.centreAxis = function (chip) {
    var rail = this.rail;
    if (!rail || !chip) return;
    if (rail.scrollWidth <= rail.clientWidth) return;
    var left = chip.offsetLeft - rail.clientWidth / 2 + chip.offsetWidth / 2;
    if (rail.scrollTo) {
      rail.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      rail.scrollLeft = left;
    }
  };

  /* 実装仕様 #3 */
  Timeline.prototype.bindJumps = function () {
    var self = this;
    this.jumps.forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (!self.live) return; // SPは素のページ内リンクのまま
        var i = parseInt(link.getAttribute('data-c-hist-tl-jump'), 10);
        var step = self.steps[i];
        if (!step) return;
        event.preventDefault();
        step.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  Timeline.prototype.destroy = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  };

  function setup() {
    for (var i = 0; i < instances.length; i++) instances[i].destroy();
    instances = [];
    var roots = document.querySelectorAll('[data-c-hist-tl]');
    for (var j = 0; j < roots.length; j++) instances.push(new Timeline(roots[j]));
  }

  setup();

  /* 実装仕様 #6 */
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', setup);
})();
